var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3247 17.4887V15.8231C13.3247 14.9396 12.9737 14.0923 12.349 13.4676C11.7243 12.8429 10.877 12.4919 9.99349 12.4919H4.99671C4.11323 12.4919 3.26593 12.8429 2.64121 13.4676C2.01649 14.0923 1.66553 14.9396 1.66553 15.8231V17.4887",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49525 9.16078C9.33501 9.16078 10.8264 7.66936 10.8264 5.8296C10.8264 3.98983 9.33501 2.49841 7.49525 2.49841C5.65548 2.49841 4.16406 3.98983 4.16406 5.8296C4.16406 7.66936 5.65548 9.16078 7.49525 9.16078Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3216 17.4887V15.8231C18.3211 15.0851 18.0754 14.3681 17.6232 13.7847C17.171 13.2014 16.5379 12.7847 15.8232 12.6002",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3247 2.60663C14.0413 2.79009 14.6764 3.20683 15.1299 3.79112C15.5834 4.37542 15.8296 5.09405 15.8296 5.83371C15.8296 6.57338 15.5834 7.292 15.1299 7.8763C14.6764 8.4606 14.0413 8.87733 13.3247 9.0608",
    stroke: "#D1D5DC",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9871,
    height: 19.9871,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.3ccdbe3989c7e5ef3684907a34894adc.svg";
export { ForwardRef as ReactComponent };